import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import type {
  ExecutionLogsParams,
  ExecutionLogsResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  interval?: number
  isPolling: boolean
  params: ExecutionLogsParams
  onSuccess: (response: ExecutionLogsResponse) => void
  children?: (response: ExecutionLogsResponse) => ReactElement
}

const PollAiExecutionLogsRequest = ({
  id,
  interval = 1000,
  isPolling,
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/executions/${id}/logs`

  return (
    <AuthenticatedPolling<ExecutionLogsResponse>
      children={children}
      intervalMs={interval}
      isPolling={isPolling}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default PollAiExecutionLogsRequest
